import { useEffect, useRef, useState } from 'react';
import type { InputSpec } from '@guess/engine';
import type { AnswerProps } from './AnswerRenderer';
import s from './input.module.scss';

type TextSpec = Extract<InputSpec, { kind: 'text' }>;

/**
 * Le champ libre : l'entree de cinq des huit mini-jeux.
 *
 * Il est mis au point sur la premiere image de la manche. Ce detail est le
 * plus rentable de tout le client : la cote passe de x3.00 a x2.20 en quatre
 * secondes, et obliger a viser un champ a la souris coute un palier entier.
 *
 * Aucune correction, aucune suggestion, aucune majuscule automatique : c'est
 * le serveur qui normalise et compare mot a mot, et une autocorrection du
 * navigateur transformerait une bonne reponse en mauvaise.
 */
export function TextAnswer({ spec, disabled, onSubmit }: AnswerProps<TextSpec>) {
  const [text, setText] = useState('');
  const fieldRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (!disabled) fieldRef.current?.focus();
  }, [disabled]);

  const submit = () => {
    const clean = text.trim();
    if (!clean || disabled) return;
    onSubmit({ kind: 'text', text: clean });
  };

  return (
    <form
      className={s.row}
      onSubmit={(event) => {
        event.preventDefault();
        submit();
      }}
    >
      <input
        ref={fieldRef}
        className={s.field}
        value={text}
        onChange={(event) => setText(event.target.value)}
        placeholder={spec.placeholder ?? 'Ta reponse'}
        disabled={disabled}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        enterKeyHint="send"
        aria-label="Ta reponse"
      />
      <button type="submit" className={s.submit} disabled={disabled || text.trim() === ''}>
        Valider
      </button>
    </form>
  );
}
